var components = {'uTransition': require('@/uni_modules/uview-ui/components/u-transition/u-transition.vue').default}
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-transition',{attrs:{"show":_vm.show,"custom-class":"u-overlay","duration":_vm.duration,"custom-style":_vm.overlayStyle},on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.clickHandler).apply(void 0, arguments)
}}},[_vm._t("default")],2)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }